// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteInput } from '@esri/calcite-components-react';

type CalciteInputProps = React.ComponentProps<typeof CalciteInput>;

export interface CalciteInputWrapperProps
  extends Omit<CalciteInputProps, 'value' | 'onChange'> {
  value: string;
  onChange?: (value: string) => void;
}

const CalciteInputWrapper: React.FC<CalciteInputWrapperProps> =
  React.forwardRef(({ disabled, value, onChange, ...rest }, ref) => {
    const onCalciteInputInput = (e: any) => {
      if (onChange) onChange((e.target as HTMLCalciteInputElement).value);
    };

    return (
      <CalciteInput
        disabled={disabled || undefined}
        value={value}
        onCalciteInputInput={onCalciteInputInput}
        ref={ref}
        {...rest}
      />
    );
  });

export default CalciteInputWrapper;
